/**
 * Component name - Dialog
 * Orig from - @lion-design/Dialog
 */
import React from 'react';

// Import module
import { Dialog } from '@lion-design/core';
import { IDialog } from '@lion-design/core/lib/src/Dialog/Module';

// Import style
import './style.scss';

// Plugin
import cx from 'classnames';

interface ICDialog extends IDialog {
  type: string
}

/**
 * @func LightBox - 光箱Component(使用@lion-design/Dialog)
 * @param {string} type - 光箱類型
 */
const DialogCustom:React.FC<ICDialog> = (props) => {
  const ModuleBody = (props:{content: string}) => {

    return (
      <div 
        className={cx('content')}
        dangerouslySetInnerHTML={{__html: props.content}}
      ></div>
    )
  }

  return (
    <Dialog
      {... props}
      body = {
        <ModuleBody
          content={props.body as string}
        />
      }
    />
  )
}

export default DialogCustom